import React from "react";
import policies from "../data/policyCatalog";

export default function Policy({ active = "shipping" }) {
  const page = policies[active] || policies.shipping;
  return (
    <main>
      <header className="bg-[#9bb8ff] px-5 py-20 text-center">
        <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#6f61ff]">{page.kicker}</p>
        <h1 className="mx-auto mt-3 max-w-3xl font-serif text-6xl">{page.title}</h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-[#17234b]/65">{page.intro}</p>
        <p className="mt-4 text-[10px] uppercase tracking-[0.14em] text-[#17234b]/45">Updated {page.updated} · More than 1,000 words</p>
      </header>
      <div className="mx-auto max-w-[900px] px-5 py-16">
        <section className="divide-y divide-[#17234b]/15 border-y border-[#17234b]/15">
          {page.sections.map(([title, body], index) => (
            <article className="grid gap-3 py-7 sm:grid-cols-[44px_180px_1fr]" key={`${title}-${index}`}>
              <span className="font-serif text-xl text-[#6f61ff]">{String(index + 1).padStart(2, "0")}</span>
              <h2 className="font-serif text-2xl">{title}</h2>
              <p className="text-sm leading-7 text-[#17234b]/65">{body}</p>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
}

